export default[
    // fields
    {
        field: 'base_salary_proportional',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Sueldo Base Proporcional',
        },
        value: '',
    },
    {
        field: 'gratification',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Gratificación',
        },
        value: '',
    },
    {
        field: 'bonuses',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Bonos',
        },
        value: '',
    },
    {
        field: 'amount_extra_hh',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Horas Extra',
        },
        value: '',
    },
    {
        field: 'commissions',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Comisiones',
        },
        value: '',
    },
    {
        field: 'total_imponible',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Total Imponible',
        },
        value: '',
    },
    {
        field: 'family_assignment',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Asignación Familiar',
        },
        value: '',
    },
    {
        field: 'total_no_imponible',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Total No Imponible',
        },
        value: '',
    },
    {
        field: 'total_haberes',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Total Haberes',
        },
        value: '',
    },
    {
        field: 'unemployment_insurance',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Seguro de Cesantía',
        },
        value: '',
    },
    {
        field: 'prevision_amount',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'AFP',
        },
        value: '',
    },
    {
        field: 'health_amount',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Afiliación',
        },
        value: '',
    },
    {
        field: 'apv',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'APV',
        },
        value: '',
    },
    {
        field: 'advance',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Anticipo',
        },
        value: '',
    },
    {
        field: 'tax_amount',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Impuestos',
        },
        value: '',
    },
    {
        field: 'discounts',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Descuentos',
        },
        value: '',
    },
    {
        field: 'liquid_salary',
        type: 'text',
        format: 'currency',
        vuetifyProps: {
            label: 'Sueldo Líquido',
        },
        value: '',
    },
]
